import type { ElementType } from 'react';
import {
  Fingerprint,
  VerifiedUserRounded,
  HistoryEduRounded,
  GavelRounded,
  SellRounded,
  StarRounded,
  LocalShippingRounded,
  StorefrontRounded,
  ShieldRounded,
  CategoryRounded,
} from '@material-ui/icons';
import { OriginFlowOperation } from '../../types/provenance';

/** Icon keys admins can pick for an Origin Identity flow, mapped to their components. */
export const FLOW_ICONS: Record<string, ElementType> = {
  fingerprint: Fingerprint,
  verified: VerifiedUserRounded,
  shield: ShieldRounded,
  provenance: HistoryEduRounded,
  grading: GavelRounded,
  sale: SellRounded,
  star: StarRounded,
  shipping: LocalShippingRounded,
  store: StorefrontRounded,
  category: CategoryRounded,
};

export const FLOW_ICON_KEYS = Object.keys(FLOW_ICONS);

/** The icon component for a flow: its chosen key, else an operation-based default. */
export const resolveFlowIcon = (
  icon: string | undefined,
  operation: OriginFlowOperation,
): ElementType => {
  if (icon && FLOW_ICONS[icon]) {
    return FLOW_ICONS[icon];
  }
  return operation === 'fingerprinting' ? Fingerprint : VerifiedUserRounded;
};
